import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ManageStore = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to new store management system
    navigate('/manage-store/information', { replace: true });
  }, [navigate]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '1.2rem',
      color: '#666'
    }}>
      Redirecting to Store Management...
    </div>
  );
};

export default ManageStore;
